import { render, staticRenderFns } from "./carousel_card.vue?vue&type=template&id=7c40cca1&scoped=true&"
import script from "./carousel_card.vue?vue&type=script&lang=js&"
export * from "./carousel_card.vue?vue&type=script&lang=js&"
import style0 from "./carousel_card.vue?vue&type=style&index=0&id=7c40cca1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c40cca1",
  null
  
)

export default component.exports